module.exports = __webpack_public_path__ + "img/alipay.059b794f.png";